<eb-cart-item-header
  *ngIf="hasHeader"
  [compact]="displayEntriesCompact"
  [showPrice]="showPriceValue"
  [hideQuantity]="hideQuantity"
></eb-cart-item-header>
<div class="cx-item-list-row" *ngFor="let item of items; let i = index">
  <ng-container *ngIf="controlled; else nonControlled">
    <div
      *ngIf="getControl(item) | async as control"
      class="cx-item-list-items"
      [class.is-changed]="control.get('quantity').disabled"
    >
      <eb-cart-item
        [item]="item"
        [quantityControl]="control.get('quantity')"
        [readonly]="readonly"
        [options]="options"
        [compact]="displayEntriesCompact"
        [showPrice]="showPriceValue"
        [showAvailability]="showAvailability"
        [prices]="
          item.product?.successor
            ? this.productPrices.get(item.product?.successor?.code)
            : this.productPrices.get(item.product?.code)
        "
        [attr.data-cy]="'cart-item-' + item.product.code"
      >
      </eb-cart-item>
    </div>
  </ng-container>
  <ng-template #nonControlled>
    <eb-cart-item
      [item]="item"
      [readonly]="readonly"
      [options]="options"
      [compact]="displayEntriesCompact"
      [showPrice]="showPriceValue"
      [showAvailability]="showAvailability"
      [prices]="
        item.product?.successor
          ? this.productPrices.get(item.product?.successor?.code)
          : this.productPrices.get(item.product?.code)
      "
      [showAddToCart]="showAddToCart"
      [hideQuantity]="hideQuantity"
    >
    </eb-cart-item>
  </ng-template>
</div>
<ng-template #totalHeader>
  <div class="cx-item-list-total col-md-2 col-lg-2 col-xl-2">
    {{ 'cartItems.total' | cxTranslate }}
  </div>
</ng-template>
